import React, { useState, useEffect } from 'react';
import axios from 'axios';

const STATUS_STYLES = {
  open: { bg: 'bg-yellow-100', text: 'text-yellow-800', label: 'Open' },
  in_progress: { bg: 'bg-blue-100', text: 'text-blue-800', label: 'In Progress' },
  resolved: { bg: 'bg-green-100', text: 'text-green-800', label: 'Resolved' },
  closed: { bg: 'bg-gray-100', text: 'text-gray-600', label: 'Closed' },
};

const CATEGORY_LABELS = {
  safety_emergency: 'Safety/Emergency',
  bug_report: 'Bug Report',
  bad_actor: 'Inappropriate Behavior',
  payment_dispute: 'Payment Dispute',
  lost_and_found: 'Lost & Found',
  general_feedback: 'Feedback',
};

const MyReports = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchMyReports();
  }, []);

  const fetchMyReports = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/reports/my-reports`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setReports(response.data.reports || []);
    } catch (err) {
      console.error('Error fetching reports:', err);
      setError('Failed to load reports');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <p className="text-sm text-gray-500 py-2">Loading reports...</p>;
  }

  if (error) {
    return <p className="text-sm text-red-600 py-2">{error}</p>;
  }

  if (reports.length === 0) {
    return <p className="text-sm text-gray-500 py-2">You haven't submitted any reports yet.</p>;
  }

  return (
    <div className="space-y-3">
      {reports.map(report => {
        const statusStyle = STATUS_STYLES[report.status] || STATUS_STYLES.open;
        const categoryLabel = CATEGORY_LABELS[report.category] || report.category;
        const createdDate = new Date(report.created_at).toLocaleDateString();

        return (
          <div key={report.id} className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition">
            <div className="flex items-start justify-between gap-3">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <span className="text-xs font-medium text-gray-500 bg-gray-100 px-2 py-0.5 rounded">
                    {categoryLabel}
                  </span>
                  <span className={`text-xs font-medium px-2 py-0.5 rounded ${statusStyle.bg} ${statusStyle.text}`}>
                    {statusStyle.label}
                  </span>
                </div>
                <h4 className="font-medium text-gray-900 text-sm truncate">{report.subject}</h4>
                <p className="text-xs text-gray-500 mt-1">
                  Report #{report.id} - {createdDate}
                  {report.resolved_at && ` · Resolved ${new Date(report.resolved_at).toLocaleDateString()}`}
                  {report.closed_at && ` · Closed ${new Date(report.closed_at).toLocaleDateString()}`}
                </p>
              </div>
            </div>
            {report.resolution_note && (
              <div className="mt-3 bg-blue-50 border border-blue-200 rounded-lg p-3">
                <p className="text-xs font-medium text-blue-700 mb-1">Response from support:</p>
                <p className="text-sm text-blue-900 whitespace-pre-wrap">{report.resolution_note}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default MyReports;
